import axios from 'axios';

const BASE_URL = process.env.REACT_APP_BACKEND_BASE_URL;

const axiosInstance = axios.create({
    baseURL: BASE_URL,
    headers: {
        'Content-Type': 'application/json',
    },
    withCredentials: true,
});
//#region Bots
export const listBots = async () => {
    return axiosInstance.get('/botpress/bots');
};

export const getBot = async (id) => {
    return axiosInstance.get(`/botpress/bots/${id}`);
};
//#endregion

//#region Conversaciones
export const createConversation = async (data) => {
    return axiosInstance.post('/botpress/conversations', data);
};

export const listConversations = async () => {
    return axiosInstance.get('/botpress/conversations');
};

export const getConversation = async (id) => {
    return axiosInstance.get(`/botpress/conversations/${id}`);
};

export const updateConversation = async (id, data) => {
    return axiosInstance.patch(`/botpress/conversations/${id}`, data);
};

export const deleteConversation = async (id) => {
    return axiosInstance.delete(`/botpress/conversations/${id}`);
};
//#endregion

//#region Mensajes
export const createMessage = async (data) => {
    return axiosInstance.post('/botpress/messages', data);
};

export const listMessages = async (conversationId) => {
    return axiosInstance.get(`/botpress/conversations/${conversationId}/messages`);
};

export const getMessage = async (id) => {
    return axiosInstance.get(`/botpress/messages/${id}`);
};

export const updateMessage = async (id, data) => {
    return axiosInstance.patch(`/botpress/messages/${id}`, data);
};

export const deleteMessage = async (id) => {
    return axiosInstance.delete(`/botpress/messages/${id}`);
};
//#endregion

//#region Usuarios
export const createUser = async (data) => {
    return axiosInstance.post('/users', data);
};

export const listUsers = async () => {
    return axiosInstance.get('/users');
};

export const getUser = async (id) => {
    return axiosInstance.get(`botpress/users/${id}`);
};

export const updateUser = async (id, data) => {
    return axiosInstance.patch(`botpress/users/${id}`, data);
};

export const deleteUser = async (id) => {
    return axiosInstance.delete(`botpress/users/${id}`);
};
//#endregion

//#region Participantes
export const listParticipants = async (conversationId) => {
    return axiosInstance.get(`/botpress/conversations/${conversationId}/participants`);
};

export const addParticipant = async (conversationId, data) => {
    return axiosInstance.post(`/botpress/conversations/${conversationId}/participants`, data);
};

export const getParticipant = async (conversationId, participantId) => {
    return axiosInstance.get(`/botpress/conversations/${conversationId}/participants/${participantId}`);
};

export const removeParticipant = async (conversationId, participantId) => {
    return axiosInstance.delete(`/botpress/conversations/${conversationId}/participants/${participantId}`);
};
//#endregion

//#region Eventos
export const createEvent = async (data) => {
    return axiosInstance.post('/botpress/events', data);
};

export const listEvents = async () => {
    return axiosInstance.get('/botpress/events');
};

export const getEvent = async (id) => {
    return axiosInstance.get(`/botpress/events/${id}`);
};
//#endregion

//#region Integraciones
// export const configureIntegration = async (data) => {
//     return axiosInstance.post('/integrations/configure', data);
// };

// export const listIntegrations = async () => {
//     return axiosInstance.get('/integrations');
// };

// export const getIntegration = async (id) => {
//     return axiosInstance.get(`/integrations/${id}`);
// };

// export const updateIntegration = async (id, data) => {
//     return axiosInstance.patch(`/integrations/${id}`, data);
// };

// export const deleteIntegration = async (id) => {
//     return axiosInstance.delete(`/integrations/${id}`);
// };
//#endregion